import { useCallback, useRef } from 'react';

import useIntersectionObserver, { UseIntersectionObserverOptions } from '@pflegia/ui/hooks/use-intersection-observer';

import { useWhatsAppOptInContext } from './WhatsAppOptInContext';

/**
 * Invisible marker rendered at the 5th job position slot. Its only purpose is to signal that the
 * candidate has scrolled that far down the job board, one of the two ways to trigger the WhatsApp
 * opt-in "browsing" popup.
 */
const WaOptInFifthJobSentinel: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { markReachedFifthJobPosition } = useWhatsAppOptInContext();

  const handleIntersection = useCallback<UseIntersectionObserverOptions['callback']>(
    entries => {
      if (entries.some(entry => entry.intersectionRatio > 0)) markReachedFifthJobPosition();
    },
    [markReachedFifthJobPosition],
  );

  useIntersectionObserver({ callback: handleIntersection, ref });

  return <div ref={ref} />;
};

export default WaOptInFifthJobSentinel;
